<ng-container *ngIf="project && editForm">
    <ng-container *ngIf="!isLoading; else loading" [formGroup]="editForm">
        <div class="cas-flex-row">
            <acabim-form-block labelWidth="8" class="col-md-4" [labelAlign]="'right'" [shortFields]="true" [colonize]="true">

                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Current Phase</acabim-form-input-label>
                    <acabim-form-input-content>
                        {{this.project?.currentPhase}}
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>

            </acabim-form-block>

            <acabim-form-block labelWidth="10" class="col-md-5" [labelAlign]="'right'" [shortFields]="true" [colonize]="true">

                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Transfer to phase</acabim-form-input-label>
                    <acabim-form-input-content>
                        <p-dropdown
                                formControlName="projectPhase"
                                optionLabel="name"
                                [options]="supportedPhaseTransfers"
                                (onChange)="onSelectedPhaseChanged($event.value)"></p-dropdown>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
        </div>

        <ng-container *ngIf="selectedPhaseTransfer">
            <acabim-qa-acabim-qa-lib [capId]="currentQaCapName" (outputResult)="onCapResult($event)"></acabim-qa-acabim-qa-lib>
            <ng-container *ngIf="showProceed">
                <div *ngIf="dateLabel" class="p-2">
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label class="required">{{dateLabel}}</acabim-form-input-label>
                        <acabim-form-input-content>
                            <p-calendar
                                #calendar
                                formControlName="constructionDate"
                                id="phase-date"
                                dateFormat="D dd MM yy"
                                [inline]="true"
                                [readonlyInput]="true"
                                [yearNavigator]="true"
                                [yearRange]="yearRange"
                                [monthNavigator]="true"></p-calendar>
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                </div>
                <div class="cas-action-buttons cas-action-buttons-bottom">
                    <button class="cas-button-action cas-button-right" (click)="transferPhase()">Proceed</button>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-template #loading>
        <acabim-loading-view></acabim-loading-view>
    </ng-template>
<!--    <p-toast position="top-right"></p-toast>-->
</ng-container>
